// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/no-unused-vars,@typescript-eslint/no-explicit-any
export function onMigrate(params, preDeployData) {
    return params.oldData;
}
